<div class="content-wrapper" style="min-height: 368px">
  <div class="pt-2 pb-2">
    <div class="card m-2">
      <div class="card-body" style="padding: 5px;">
        <h2>Coming soon..</h2>
      </div>
    </div>
  </div>
</div>
